import React from 'react';
import { registerFormat } from '../registry';
import { pdfCapabilities } from './capabilities';
import type { FormatDefinition, FormatRenderOptions, FormatRenderResult } from '../types';

const pdfFormat: FormatDefinition = {
  id: 'pdf',
  displayName: 'PDF',
  fileExtension: 'pdf',
  mimeType: 'application/pdf',
  defaultDpi: 72,
  dpiOptions: [
    { label: 'Standard (72 DPI)', value: 72, recommended: true },
  ],
  capabilities: pdfCapabilities,
  recommended: true,

  PreviewPanel: React.lazy(() => import('./PdfPreviewPanel')),

  templateDefaults: {
    background: '#f7f8fa',
  },

  async renderLabels(options: FormatRenderOptions): Promise<FormatRenderResult> {
    const { generateLabelPdf } = await import('../../services/pdfGenerator');
    const result = await generateLabelPdf({
      template: options.template,
      layout: options.layout,
      labelCount: options.labelCount,
      rotation: options.rotation,
      topOffset: options.topOffset,
      leftOffset: options.leftOffset,
      qrIndexOffset: options.qrIndexOffset,
      data: {
        common: options.data.common as Record<string, any>,
        coa: options.data.coa as Record<string, any>,
        product: options.data.product as Record<string, any>,
        job: options.data.job as Record<string, any>,
        qrValues: options.data.qrValues,
      },
      legacyImages: options.legacyImages,
      legacyFonts: options.legacyFonts,
      newAssetImages: options.newAssetImages,
      newAssetFonts: options.newAssetFonts,
      fontSources: options.fontSources,
      defaultFont: options.defaultFont,
      variableExamples: options.variableExamples,
      retailIdData: options.retailIdData,
      isPreview: options.isPreview,
      hasCoa: options.hasCoa,
    });

    return {
      format: 'pdf',
      blob: result.blob,
      url: result.url,
      labelCount: options.labelCount,
      extra: {
        pdfBytes: result.pdfBytes,
        pageCount: result.pageCount,
        labelsPerPage: result.labelsPerPage,
      },
    };
  },

  revokeUrl(url: string) {
    URL.revokeObjectURL(url);
  },
};

registerFormat(pdfFormat);

export default pdfFormat;
